import { type Reducer, combineReducers } from 'redux';
import type { OptimisticState } from 'redux-optimistic-ui';
import type { Action } from '../types';
import config from './config/reducer';
import entities from './entities/reducer';
import type { EntitiesState } from './entities/types';
import type { State } from './types';
import ui from './ui/reducer';

export default combineReducers<State>({
	ui,
	// Need cast to open-up store to | type that isn't only handling optimistic
	// state. This is due to `optimistic(...)` from redux-optimistic-ui not
	// being fully type-safe.
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	entities: entities as Reducer<EntitiesState | OptimisticState<EntitiesState>, Action>,
	config,
});
